export default __webpack_public_path__ + "static/media/darktemplar_color.11353688.png";